<div class="t-popup-body" style="overflow: auto;"  [formGroup]="gastroFormsService.Form">
    <button class="t-btn-popup-close" aria-label="close popup" (click)="close(true)"></button>
    <div class="formHeader">
        <h2 style="align-self: center;">
            Admission Form
        </h2>
        <span (click)="printForm()" class="icon-print" style="margin-inline-end: 1.5em;" aria-label="Print" matTooltip="Print"><img src="../../../assets/icons/print.svg"></span>
    </div>
    <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between;">
        <section class="w100" style="direction: rtl; justify-content: space-evenly; display: flex;">
            <span>זיהוי מטופל <input type="checkbox" formControlName="PatientIdentification"></span>
            <span> בדיקות לביצוע:</span>
            <span>קולונוסקופיה <input type="checkbox" formControlName="Colonoscopy"></span>
            <span>גסטרוסקופיה <input type="checkbox" formControlName="Gastroscopy"></span>
            <span>סיגמואידוסקופיה <input type="checkbox" formControlName="Sigmoidoscopy"></span>
        </section>
        <div style="display: flex; margin: 0 3.5em;">
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em; align-self: center;">
                    שעת קבלה
                </span>
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="time" id="CheckTime" formControlName="AdmissionTime" />
                </span>
            </div>
            <div class="w20" style="display: flex;margin-top: 0; margin: 0.3em;">
                <span style="margin-left: 0.3em; align-self: center;">
                    רופא
                </span>
                <span class="t-field t-field--number" style="direction: rtl;">
                    <input class="t-field-text" type="text" formControlName="AssignedDoctor" />
                </span>
            </div>
        </div>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;justify-content: space-between;" >
        <h2>מדדים</h2>
        <div style="display: flex">
            <div class="w20" style="display: flex;margin-top: 0; margin: 0.3em;">
                <span style="margin-left: 0.3em;align-self: center;">חום</span> 
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="number" min="0" id="Temp"
                        formControlName="Temp" />
                    <span class="t-field-desc">
                        *C
                    </span>
                </span>
            </div>
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em;align-self: center;">דופק</span> 
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="number" min="0" id="Pulse"
                        formControlName="Pulse" />
                    <span class="t-field-desc">
                        bpm
                    </span>
                </span>
            </div>                
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 5px;align-self: center;">לחץ דם</span>
                    <!-- <span>
                        לחץ דם
                    </span>
                    <span class="t-field t-field--number" style="max-width: fit-content">
                        <input class="t-field-text" type="number" min="0" formControlName="bpSystolic" style='width: 4em'/>/<input class="t-field-text" type="number" min="0" formControlName="bpDyastolic" style='width: 4em'>
                        <span class="t-field-desc">
                           mmHg
                    </span> -->
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="number" min="0" formControlName="bpSystolic" style='width: 3em;text-align: center;text-align-last: center;'/>/<input class="t-field-text" type="number" min="0" formControlName="bpDyastolic" style='width: 3em;text-align: center;text-align-last: center;'>
                    <span class="t-field-desc" style="padding: 0.3em;">
                        mmHg
                    </span>
                </span>
            </div>
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em;align-self: center;">סיטורציה</span> 
                <span class="t-field t-field--number" style="direction: ltr;min-width: 6.31em;">
                    <input class="t-field-text" type="number" min="0" formControlName="Saturation" style='text-align: center;text-align-last: center;'/>
                    <span class="t-field-desc" style="padding: 0.3em;">
                        %
                    </span>
                </span>
            </div>
            <div class="w20" style="display: flex; margin: 0.3em;">
                <span style="margin-left: 0.3em;align-self: center;">שעת הבדיקה</span> 
                <span class="t-field t-field--number" style="direction: ltr;">
                    <input class="t-field-text" type="time" id="CheckTime"
                        formControlName="CheckTime" />
                </span>
            </div>
        </div>
    </div>
    <div class="m-box" style="direction: rtl; margin: 1em 0; justify-content: space-between">
        <label class="t-label-top">
          <span style="width: 8em">מדד כאב 0-10: </span>
          <div
            class="l-flex-c l-flex-w indicative-fieldset"
            style="flex-wrap: inherit; direction: rtl"
            (dblclick)="gastroFormsService.Form.get('AdmissionPainLevel').setValue('')"
          >
            <label class="t-label-top">
              <input type="radio" formControlName="AdmissionPainLevel" value="painless" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span style="margin-right: 0.5em"> אין כאב בכלל </span>
            </label>
            <label class="t-label-top">
              <input type="radio" formControlName="AdmissionPainLevel" value="lowPain" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span style="margin-right: 0.5em"> כאב מועט </span>
            </label>
    
            <label class="t-label-top">
              <input type="radio" formControlName="AdmissionPainLevel" value="mediumPain" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span style="margin-right: 0.5em"> כאב בינוני </span>
            </label>
    
            <label class="t-label-top">
              <input type="radio" formControlName="AdmissionPainLevel" value="strongPain" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span style="margin-right: 0.5em"> כאב חזק </span>
            </label>
    
            <label class="t-label-top">
              <input type="radio" formControlName="AdmissionPainLevel" value="fullPain" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span style="margin-right: 0.5em"> כאב בלתי נסבל </span>
            </label>
          </div>
        </label>
      </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;;">
        <h2>הרגלים</h2>
        <div style="z-index: 7;">
            <div  style="display: flex;z-index: 1000;">
                <app-patformsitem type="Smokes" name="Smokes" style="margin-top: 0;width:16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Alcohol" name="Alcohol" style="width: 16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Drugs" name="Drugs" style="width: 16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Sleep" name="Sleep" style="width: 16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Allergies" name="Allergies" style="width: 16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="DrugsAllergies" name="DrugsAllergies" style="width: 16%;margin: 0.5em;text-align: center;"></app-patformsitem>
            </div>
        </div>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;" >
        <h2>הכנת המטופל</h2>
        <div style="z-index: 6;">
            <div style="display: flex;">
                <app-patformsitem type="Nursing" name="Nursing" style="margin-top: 0;width:16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="OSA" name="OSA" style="margin-top: 0;width:16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="DAC" name="DAC" style="margin-top: 0;width:16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Dentures" name="Dentures" style="margin-top: 0;width:16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Escorted" name="Escorted" style="margin-top: 0;width:16%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Guardian" name="Guardian" style="margin-top: 0;width:16%;margin: 0.5em;text-align: center;"></app-patformsitem>
            </div>
        </div>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;z-index: inherit;" >
        <h2>מחלות</h2>
        <div style="z-index: 5;">
            <div style="display: flex;padding: 0.3em;">
                <app-patformsitem type="Hypertension" name="Hypertension" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="RespiratoryDiseases" name="RespiratoryDiseases" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Arrhythmias" name="Arrhythmias" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Diabetes" name="Diabetes" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Hepatitis" name="Hepatitis" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
            </div>
            <div style="display: flex;padding: 0.3em;">
                <app-patformsitem type="Cancer" name="Cancer" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Radiation" name="Radiation" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Cramps" name="Cramps" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Psychiatric" name="Psychiatric" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Nervous" name="Nervous" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
            </div>
        </div>
    </div>
    <div style="display: flex;justify-content: space-between;">
        <div class="w40" style="direction: rtl;margin: 0;height: fit-content;" >
            <app-patformsitem type="PreMedication" name="PreMedication" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
        </div>
        <div class="w40" style="direction: rtl;margin-left: 0.5em;height: fit-content;" >
            <app-patformsitem type="Surgeries" name="Surgeries" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
        </div>
    </div>
    <div class="m-box" style="direction: rtl;margin: 1em 0;" >
        <h2>מצב היום</h2>
        <div style="z-index: 4;">
            <div style="display: flex;justify-content: space-evenly;">
                <app-patformsitem type="Medication" name="Medication" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="BloodThinners" name="BloodThinners" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
                <app-patformsitem type="Fast" name="Fast" style="margin-top: 0;width:20%;margin: 0.5em;text-align: center;"></app-patformsitem>
            </div>
        </div>
    </div>
    <div class="m-box" style="display: flex; direction: rtl; gap: 1em; margin: 1em 0;">
    <div class="m-box w50" style="direction: rtl; margin: 1em 0;" >
        <h2>מצב רגשי</h2>
        <div style="z-index: 4;">
            <div style="display: flex;justify-content: space-evenly;">
                <div class="l-flex-c l-flex-w l-justify h50 placenta-row" (dblclick)="resetFormField('EmotionalStatus')">
                    <label class="t-label-top">
                        <input type="radio" name="EmotionalStatus" class="custom-check" formControlName="EmotionalStatus" value="נינוח"/>
                        <i class="customInput-display"></i>
                        <span style="padding: 0 1em;">
                            נינוח
                        </span>
                    </label>
                    
                    <label class="t-label-top">
                        <input type="radio" name="EmotionalStatus" class="custom-check" formControlName="EmotionalStatus" value="נרגש"/>
                        <i class="customInput-display"></i>
                        <span style="padding: 0 1em;">
                            נרגש
                        </span>
                    </label>
                    
                    <label class="t-label-top">
                        <input type="radio" name="EmotionalStatus" class="custom-check" formControlName="EmotionalStatus" value="חרד"/>
                        <i class="customInput-display"></i>
                        <span style="padding: 0 1em;">
                            חרד
                        </span>
                    </label>
                </div>
            </div>
        </div>

        </div>
        <div class="m-box w50" style="direction: rtl; margin: 1em 0;">
            <h2>הערה כללית</h2>
            <button
              *ngIf="!examService.isClosed && ls.premissions && ls.premissions['Questionnaires']"
              class="t-btn-smart"
              [disabled]="aiSummaryLoading"
              style="margin-bottom: 0.5em"
              (click)="getAiSummary()"
            >
              {{ 'GUI.General.Buttons.Populate Smart History' | translate }}
              <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
            </button>
            <textarea
              class="fulltext minH8"
              formControlName="GeneralComment"
              style="height: 100%; width: 100%;"
            ></textarea>
            <button
              *ngIf="!examService.isClosed"
              class="t-btn-edit"
              (click)="autoTextService.showAuto(gastroFormsService.Form.get('GeneralComment'),'GeneralComment',720)"
            >
              Auto Text
            </button>
          </div>
          
    </div>
    
    <div class="m-box" style="direction: rtl; margin: 1em 0;">
        <h2>הדרכה מקדימה </h2>
        <textarea
          class="fulltext minH8"
          formControlName="PreliminaryTraining"
          style="height: 100%; width: 100%;"
        ></textarea>
        <button
          *ngIf="!examService.isClosed"
          class="t-btn-edit"
          (click)="autoTextService.showAuto(gastroFormsService.Form.get('PreliminaryTraining'),'Preliminary training',721)"
        >
          Auto Text
        </button>
      </div>
    <
    <div style="display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: row-reverse;">
        <button class="accept" (click)="close(true)">Save and Close</button>
        <div style="display: grid;place-self: center;justify-items: end;">
            <span> חתימת האח/ות</span>
            <canvas id="canvasDoc" #canvasSign [style.border]="'1px solid black'"  [ngClass]="'can-shadow'" width="200" height="100"   (click)="setCanvas()"></canvas>
            <button   style="position: relative;top: -2em;width: fit-content;" (click)="clearSign()">                                            
                <ng-container>
                    <img src="../../assets/icons/login/reset.png" style='height: 1.5em;width: 1.5em' matTooltip="Clear">
                </ng-container>
            </button>
    
        </div>
    </div>
</div>
<app-autotext *ngIf="autoTextService.Display"></app-autotext>